<template>
    <div class="row">

        <div class="col-lg-7">
            <div class="row">
                <div class="col-lg-8">
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="selling-type-with-passenger" name="baggageSellingType"
                               class="custom-control-input"
                               :value="baggageShippingTypes.WITH_PASSENGER"
                               v-model="baggageShippingType"
                        >
                        <label class="custom-control-label"
                               for="selling-type-with-passenger">{{i18n('For a passenger ticket')}}</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="selling-type-without-passenger" name="baggageSellingType"
                               class="custom-control-input"
                               :value="baggageShippingTypes.WITHOUT_PASSENGER"
                               v-model="baggageShippingType"
                        >
                        <label class="custom-control-label" for="selling-type-without-passenger">
                            {{ i18n('For trip') }}
                        </label>
                    </div>
                </div>
            </div>
            <div v-if="isBaggageWithoutPassenger">
                <div class="row">
                    <div class="col-sm-4">
                        <div class="input-group day date">
                            <label class="col-form-label">{{i18n('Departure date')}}:</label>
                            <datepicker
                                v-model="trip_date"
                                :inputClass="'form-control base_input'"
                                :bootstrap-styling="true"
                                :calendar-button="true"
                                :disabled-dates="disabledDates"
                                calendar-button-icon="mdi mdi-calendar"
                                format="dd.MM.yyyy" class="m_datepicker">
                            </datepicker>
                            <!--:disabled-dates="disabledDates"-->
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="col-form-label">{{i18n('Point of departure')}}:</label>
                            <model-list-select :list="stations"
                                               v-model="station_from"
                                               option-value="id"
                                               option-text="name"
                                               :placeholder="i18n('Select stations')">
                            </model-list-select>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="col-form-label">{{i18n('Destination')}}:</label>
                            <model-list-select :list="stations"
                                               v-model="station_to"
                                               option-value="id"
                                               option-text="name"
                                               :placeholder="i18n('Select stations')">
                            </model-list-select>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-4">
                        <button type="button" class="btn base_btn solid_blue waves-effect waves-light form-control"
                                @click="searchTrip()">
                            {{i18n('Search flights')}}
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="isBaggageWithPassenger" class="row mt-3">
                <div class="col-md-6">
                    <input type="text" class="form-control base_input" v-model="ticket_id"
                           @keypress.enter="findByTicketId"/>
                </div>
                <div class="col-md-6">
                    <button type="submit" class="btn base_btn solid_blue waves-effect waves-light form-control"
                            @click="findByTicketId()">
                        {{i18n('Check ticket')}}
                    </button>
                </div>
            </div>
            <div v-else-if="isBaggageWithoutPassenger" class="row mt-3">
                <div class="col-md-8 mb-3">
                    <model-list-select id="trip_id" v-if="trips.length > 0"
                                       :list="trips"
                                       v-model="trip_id"
                                       option-value="trip_id"
                                       :custom-text="tripInfo"
                                       :placeholder="i18n('Select a trip for baggage')"
                    >
                    </model-list-select>
                </div>
            </div>

            <div v-if="ticket">
                <div class="row">
                    <div class="col-sm-12">
                        <table class="table table-striped table-hover mt-3">
                            <tr>
                                <td><strong>{{i18n('Trip')}}</strong></td>
                                <td>{{ticket.trip_name}}</td>
                            </tr>
                            <tr>
                                <td><strong>{{i18n('Passenger')}}</strong></td>
                                <td>{{ticket.passenger.full_name}}</td>
                            </tr>
                            <tr>
                                <td><strong>{{i18n('Departure time')}}</strong></td>
                                <td>{{ticket.trip.time}}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ i18n('Free baggage allowance') }}</strong></td>
                                <td>{{ticket.trip.free_baggage_allowance}}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ i18n('Max baggage allowance') }}</strong></td>
                                <td>{{ticket.trip.max_baggage_allowance}}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ i18n('Tariff defined baggage price') }}</strong></td>
                                <td>{{ticket.tariff_defined_baggage_price}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div v-if="ticket || trip">
                <div class="row">
                    <div class="col-sm-6">
                        <label for="baggage-weight"><strong>{{i18n('Baggage weight in kg')}}.</strong></label>
                        <input id="baggage-weight" type="text" class="form-control base_input"
                               :disabled="disable_all_form"
                               @keypress.enter="calcBaggagePrice"
                               @change="calcBaggagePrice"
                               v-model="$v.baggage_weight.$model"
                               :class="{ 'is-invalid-self': $v.baggage_weight.$error }"
                        />
                    </div>
                    <div class="col-md-6">
                        <label>&nbsp;&nbsp;</label>
                        <table class="table table-striped table-hover">
                            <tr>
                                <td><strong> {{i18n('Cost')}}</strong></td>
                                <td>{{baggage_price}}</td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-sm-6" v-show="baggage_price !== null && isBaggageWithoutPassenger">
                        <label for="sender_name"><strong>{{i18n('Sender name')}}</strong></label>
                        <input :disabled="disable_all_form" type="text" id="sender_name" class="form-control base_input"
                               max="40"
                               v-model="sender_name">
                    </div>
                    <div class="col-sm-6" v-show="baggage_price !== null && isBaggageWithoutPassenger">
                        <label for="receiver_name"><strong>{{i18n('Receiver name')}}</strong></label>
                        <input :disabled="disable_all_form" type="text" id="receiver_name"
                               class="form-control base_input" max="40"
                               v-model="receiver_name">
                    </div>
                    <div class="col-sm-6" v-show="baggage_price !== null && isBaggageWithoutPassenger">
                        <label for="sender_phone"><strong>{{i18n('Sender phone')}}</strong></label>
                        <input :disabled="disable_all_form" type="text" id="sender_phone" placeholder="+998901234567"
                               class="form-control base_input" min="13" max="13"
                               v-model="sender_phone">
                    </div>
                    <div class="col-sm-6" v-show="baggage_price !== null && isBaggageWithoutPassenger">
                        <label for="receiver_phone"><strong>{{i18n('Receiver phone')}}</strong></label>
                        <input :disabled="disable_all_form" type="text" id="receiver_phone" placeholder="+998901234567"
                               class="form-control base_input" min="13" max="13"
                               v-model="receiver_phone">
                    </div>
                    <div class="col-sm-6 mt-3">
                        <button type="submit" class="btn base_btn solid_blue waves-effect waves-light form-control"
                                :disabled="baggage_price_calculating"
                                @click="calcBaggagePrice()">
                            {{i18n('Calculate the cost')}}
                        </button>
                    </div>
                    <div class="col-sm-6 mt-3" v-show="baggage_price !== null">
                        <button type="submit" class="btn base_btn solid_blue waves-effect waves-light form-control"
                                :disabled="disable_all_form"
                                @click="pay()">
                            {{i18n('Pay')}}
                        </button>
                    </div>
                </div>
            </div>


        </div>

        <!--    <div class="row">-->
        <!--      <div class="col-xl-3 col-sm-4">-->
        <!--        Не найдено ни одного ...! Проверьте правильность-->
        <!--        номер билета-->
        <!--      </div>-->
        <!--    </div>-->

        <div v-if="baggage" class="col-lg-5">
            <div class="row">
                <div class="col-lg-12" id="printStatement" ref="printStatement">
                    <table class="table table-striped table-hover">
                        <tr>
                            <td>{{ i18n('Trip id') }}</td>
                            <td>{{ baggage.trip_id }}</td>
                        </tr>
                        <tr>
                            <td>{{ i18n('Trip') }}</td>
                            <td>{{ baggage.trip }}</td>
                        </tr>
                        <tr>
                            <td>{{ i18n('Baggage weight') }}</td>
                            <td>{{ baggage.baggage_weight }} кг.</td>
                        </tr>
                        <tr>
                            <td>{{ i18n('Departing') }}</td>
                            <td>{{ baggage.departing }}</td>
                        </tr>
                        <tr>
                            <td>{{ i18n('Arriving') }}</td>
                            <td>{{ baggage.arriving }}</td>
                        </tr>
                        <tr>
                            <td>{{ i18n('Departure time') }}</td>
                            <td>{{ baggage.departure_time | moment('YYYY-MM-DD') }}</td>
                        </tr>
                        <tr>
                            <td>{{ i18n('Cashier') }}</td>
                            <td>{{ baggage.cashier }}</td>
                        </tr>
                        <tr v-show="baggageShippingType === baggageShippingTypes.WITH_PASSENGER">
                            <td>{{ i18n('Passenger name') }}</td>
                            <td>{{ baggage.passenger_name }}</td>
                        </tr>
                        <tr>
                            <td>{{ i18n('Sold time') }}</td>
                            <td>{{ baggage.sold_time.date | moment('YYYY-MM-DD') }}</td>
                        </tr>
                        <tr>
                            <td>{{ i18n('Total amount') }}</td>
                            <td>{{ baggage.total_amount }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <a class="btn base_btn" :href="baggage.baggage_ticket" target="_blank">{{ i18n('Print out') }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {ModelListSelect} from 'vue-search-select';
    import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
    import {validationMixin} from 'vuelidate';
    import {required, maxValue} from 'vuelidate/lib/validators';


    export default {
        name: "BaggageSelling",
        props: {
            stations: Array,
        },
        components: {ModelListSelect, Datepicker},
        mixins: [validationMixin],
        validations() {
            return {
                baggage_weight: {
                    required,
                    maxValue: maxValue(this.maxBaggageAllowance)
                }
            }
        },
        computed: {
            isBaggageWithPassenger: function () {
                return this.baggageShippingType === this.baggageShippingTypes.WITH_PASSENGER;
            },
            isBaggageWithoutPassenger: function () {
                return this.baggageShippingType === this.baggageShippingTypes.WITHOUT_PASSENGER;
            },
        },
        data() {
            return {
                trips: [],
                ticket_id: null,
                trip_id: null,
                ticket: null,
                trip: null,
                maxBaggageAllowance: 0,
                trip_date: null,
                station_from: 1,
                station_to: null,
                baggage: null,
                baggage_weight: null,
                baggage_price: null,
                disable_all_form: false,
                baggage_price_calculating: true,
                sender_name: '',
                receiver_name: '',
                sender_phone: '',
                receiver_phone: '',
                baggageShippingType: 1,
                baggageShippingTypes: {
                    WITH_PASSENGER: 1,
                    WITHOUT_PASSENGER: 2,
                },
                disabledDates: {
                    to: this.getYesterday()
                }
            }
        },
        created() {
            Object.freeze(this.baggageShippingTypes);
        },
        methods: {
            getYesterday() {
                let d = new Date();
                d.setDate(d.getDate() - 1);
                return d;
            },
            tripInfo(trip) {
                return `№ ${trip.trip_id} / ${trip.route_name} / ${trip.trip_time}`;
            },
            searchTrip() {
                if (this.trip_date === null || this.station_from === null || this.station_to === null) {
                    return;
                }
                this.$api.post('cashier.dashboard-one', {
                    date: this.trip_date,
                    from: this.station_from,
                    to: this.station_to,
                }).then(({data}) => {
                    this.trips = data.data;
                    this.$store.state.dailyTrips = this.trips;
                });
                this.resetForm();
            },
            findByTicketId() {
                this.$api.get('baggage-selling.ticket', {passenger_id: this.ticket_id})
                    .then(res => {
                        if (!_.isEmpty(res.errors)) {
                            this.notifyError(res);
                            return;
                        }
                        this.ticket = res.data;
                        this.trip = res.data.trip;
                        this.maxBaggageAllowance = this.trip.max_baggage_allowance;
                        this.trip_id = this.trip.id;
                        if (this.isBaggageWithPassenger) {
                            this.sender_name = 'own';
                            this.receiver_name = 'own';
                        }
                    })
                    .catch(errResponse => {
                        errResponse = errResponse.response.data;
                        this.notifyError(errResponse);
                    });
            },
            calcBaggagePrice() {
                this.$v.baggage_weight.$touch();
                if (this.$v.baggage_weight.$invalid) {
                    return;
                }
                this.baggage_price_calculating = true;
                let tripId =
                    this.baggageShippingType === this.baggageShippingType.WITH_PASSENGER
                        ? this.ticket.trip.id : this.trip_id;
                this.$api.get('baggage-selling.calcPrice', {
                    baggage_shipping_type: this.baggageShippingType,
                    trip_id: tripId,
                    passenger_id: this.ticket_id,
                    baggage_weight: this.baggage_weight,
                    station_from: this.station_from,
                    station_to: this.station_to,
                }).then(res => {
                    this.baggage_price_calculating = false;
                    if (!_.isEmpty(res.errors)) {
                        this.notifyError(res);
                        return;
                    }
                    this.baggage_price = res.data.baggage_price
                }).catch(err => {
                    this.notifyError(err.response.data);
                });
            },
            pay() {
                this.disable_all_form = true;
                this.baggage_price_calculating = true;
                let tripId =
                    this.baggageShippingType === this.baggageShippingType.WITH_PASSENGER
                        ? this.ticket.trip.id : this.trip_id;
                this.$api.get('baggage-selling.pay', {
                    baggage_shipping_type: this.baggageShippingType,
                    trip_id: tripId,
                    sender_name: this.sender_name,
                    receiver_name: this.receiver_name,
                    sender_phone: this.sender_phone,
                    receiver_phone: this.receiver_phone,
                    passenger_id: this.ticket_id,
                    baggage_weight: this.baggage_weight,
                    station_from: this.station_from,
                    station_to: this.station_to,
                }).then(res => {
                    this.baggage = res.data;
                    this.$notify({
                        type: 'success',
                        group: 'foo',
                        title: '',
                        text: this.i18n('Paid'),
                    });
                }).catch(error => {
                    this.disable_all_form = false;
                    this.baggage_price_calculating = false;
                    this.$notify({
                        type: 'error',
                        group: 'foo',
                        title: '',
                        text: !_.isEmpty(error.response.data.message) ? error.response.data.message : error.message,
                    });
                });
            },
            printStatement(statement) {
                let fontSize = this.$refs[statement].style.fontSize;
                this.$refs[statement].style.fontSize = '13.5px';
                let mywindow = window.open('', 'PRINT');
                mywindow.document.write('<html><head><title>' + document.title + '</title>');
                mywindow.document.write('<link rel="stylesheet" href="/css/lib.css" />');
                mywindow.document.write('<link rel="stylesheet" href="/css/app.css" />');
                mywindow.document.write('<style>@media print {table{max-width: 450px}}</style>');
                mywindow.document.write('</head><body >');
                mywindow.document.write(document.getElementById(statement).innerHTML);
                mywindow.document.write('</body></html>');

                mywindow.document.close();
                mywindow.focus();
                this.$refs[statement].style.fontSize = fontSize;

                setTimeout(() => {
                    mywindow.print();
                    mywindow.close();
                }, 1000)
            },
            notifyError(errResponse) {
                let message = errResponse.message;
                if (errResponse.hasOwnProperty('errors')) {
                    for (let error in errResponse.errors) {
                        if (errResponse.errors[error].hasOwnProperty('message')) {
                            message = errResponse.errors[error].message;
                            continue;
                        }
                        if (errResponse.errors.hasOwnProperty(error)) {
                            message += "<br /> - " + errResponse.errors[error];
                        }
                    }
                }
                this.$notify({
                    type: 'error',
                    group: 'foo',
                    title: '',
                    text: message,
                });
            },
            resetForm() {
                this.baggage_price = null;
                this.baggage_weight = null;
                this.disable_all_form = false;
                this.baggage_price_calculating = false;
            }
        },
        watch: {
            trip_id: function (trip_id) {
                if (!trip_id) {
                    return;
                }
                this.resetForm();
                this.trip = this.trips.find(trip => trip.trip_id === trip_id);
            },
            baggageShippingType: function (val) {
                this.ticket = null;
                this.ticket_id = null;
                this.trip = null;
                this.trip_id = null;
                this.baggage = null;
                this.baggage_price = null;
            },
        }
    }
</script>

<style scoped></style>
